import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Close } from 'src/Images/icons/common/close.svg';
import { ReactComponent as Calendar } from 'src/Images/icons/common/calendar.svg';
import { ReactComponent as ArrowRight } from 'src/Images/icons/common/arrowright.svg';
import FilterMultiSelect from 'src/utils/FilterMultiSelect';
import getColorCode from 'src/utils/GetThemeColor';
import {
  getAssignedStages,
  getPlants,
} from 'src/redux/Actions/VehicleTracking';

const directionOptions = [
  { value: '1', label: 'Inward' },
  { value: '2', label: 'Outward' },
];
const booleanOptions = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

export default function TransporterListMobileFilterDrawer({
  formData,
  handleSearchInputChange,
  handleResetFilter,
  handleApplyFilter,
  closeFilter,
  workflowStageOptions,
  plantOptions,
  workflowStageValue,
  plantValue,
  tenantOrganisationId,
  profileId,
}) {
  const dispatch = useDispatch();
  const themeColor = useSelector(
    (state) => state.AuthReducer?.userData?.tenant?.theme,
  );

  return (
    <div className="div-flex-column">
      <div
        className="filter-list-item div-flex-row div-space-between div-align-center border-bottom"
        data-testid="filter-drawer"
      >
        <span className="text-sm text-semi-bold">Filter</span>
        <button
          className="icon-btn-none"
          onClick={closeFilter}
          aria-label="Close filter"
        >
          <Close className="icon-size-sm" color={getColorCode(themeColor)} />
        </button>
      </div>
      <div className="div-flex-column div-space-between rg-20">
        <div className="filter-list-item-container-scroll div-flex-column">
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Direction</span>
            <select
              name="direction"
              value={formData.direction || ''}
              onChange={handleSearchInputChange}
              className="form-input-section"
            >
              <option value="">Select Direction</option>
              {directionOptions.map((option) => (
                <option value={option.value} key={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Workflow Stage</span>
            <div className="input-wrapper">
              <FilterMultiSelect
                isMulti={false}
                name="workflowStageId"
                className="multi-select-input-section"
                value={workflowStageValue}
                options={workflowStageOptions}
                classNamePrefix="react-select"
                placeholder="Select Stage"
                onFocus={() => dispatch(getAssignedStages(profileId, [1, 2]))}
                onChange={(selectedOption) =>
                  handleSearchInputChange({
                    target: {
                      name: 'workflowStageId',
                      value: selectedOption?.value || '',
                    },
                  })
                }
              />
              <span className="form-input-section-icon">
                <ArrowRight
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                  style={{ transform: 'rotate(90deg)' }}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Plant</span>
            <div className="input-wrapper">
              <FilterMultiSelect
                isMulti={false}
                name="plantId"
                className="multi-select-input-section"
                value={plantValue}
                options={plantOptions}
                classNamePrefix="react-select"
                placeholder="Select Plant"
                onFocus={() => dispatch(getPlants(tenantOrganisationId))}
                onChange={(selectedOption) =>
                  handleSearchInputChange({
                    target: {
                      name: 'plantId',
                      value: selectedOption?.value || '',
                    },
                  })
                }
              />
              <span className="form-input-section-icon">
                <ArrowRight
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                  style={{ transform: 'rotate(90deg)' }}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Start Date</span>
            <div className="input-wrapper">
              <input
                type="date"
                name="startDate"
                value={formData.startDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">End Date</span>
            <div className="input-wrapper">
              <input
                type="date"
                name="endDate"
                value={formData.endDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Insurance Start Date</span>
            <div className="input-wrapper">
              <input
                type="date"
                name="insuranceStartDate"
                value={formData.insuranceStartDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Insurance End Date</span>
            <div className="input-wrapper">
              <input
                type="date"
                name="insuranceEndDate"
                value={formData.insuranceEndDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">
              Fitness Certificate Start Date
            </span>
            <div className="input-wrapper">
              <input
                type="date"
                name="fitnessCertificateStartDate"
                value={formData.fitnessCertificateStartDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">
              Fitness Certificate End Date
            </span>
            <div className="input-wrapper">
              <input
                type="date"
                name="fitnessCertificateEndDate"
                value={formData.fitnessCertificateEndDate || ''}
                onChange={handleSearchInputChange}
                className="form-input-section input-icon-date"
              />
              <span className="form-input-section-icon">
                <Calendar
                  className="icon-size-sm"
                  color={getColorCode(themeColor)}
                />
              </span>
            </div>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">Completed</span>
            <select
              name="completed"
              value={formData.completed}
              onChange={handleSearchInputChange}
              className="form-input-section"
            >
              <option value="">Select</option>
              {booleanOptions.map((option) => (
                <option value={option.value} key={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-list-item div-flex-column rg-5">
            <span className="text-sm text-semi-bold">On Hold</span>
            <select
              name="isOnHold"
              value={formData.isOnHold}
              onChange={handleSearchInputChange}
              className="form-input-section"
            >
              <option value="">Select</option>
              {booleanOptions.map((option) => (
                <option value={option.value} key={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="div-flex-row div-space-between div-align-center border-top filter-list-item footer-content-for-component">
          <button
            className={`common-btn-outlined border-${themeColor}`}
            onClick={handleResetFilter}
            data-testid="filter-reset-btn"
          >
            Reset
          </button>
          <button
            className={`common-btn theme-background-${themeColor}`}
            onClick={handleApplyFilter}
            data-testid="filter-apply-btn"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
